<style>
#notification {
    border-top: 1px solid #eee;
    padding: 15px;
    margin-left: -15px;
    cursor: pointer;
    user-select: none;
}

#notification:hover {
    background-color: whitesmoke;
}

#notification:active {
    background-color: whitesmoke;
}

#username {
    color: #999;
    font-size: 12px;
}

.unread {
    background-color: rgba(255, 166, 0, 0.199);
}

.badge {
    padding: 3px;
    border-radius: 10px;
    background-color: ghostwhite;
}

@media (max-width:972px) {
    #notification:hover {
        background: none;
    }
}
</style>

<script>
import { onMount } from 'svelte';
import {push} from './pt-router/Router.svelte'
import * as Common from './Common.js'

export let notification;

function goToComment(e) {
    e.currentTarget.style.backgroundColor = 'rgb(220, 220, 230)'
    setTimeout(() => {
        push('/comment/' + notification.content_id)
    }, 200)
}

function goToItem(e) {
    push('/item/' + notification.content_id)
}

let unread = false
onMount(() => {
    console.log(notification)
    unread = (notification.read == 0);
    if(notification.read == 0) {
        notification.read = 1;
    }
})

</script>

{#if notification}
<div class="rich-content-holder">
    {#if notification.type === Common.NOTIFICATION_TYPE_ITEM || notification.type === Common.NOTIFICATION_TYPE_COMMENT}
        <div id="notification" class={unread ? 'unread' : ''} on:click={(e) => goToComment(e)}>
            <div id="username">
                <a href={"#/user/" + notification.sender_userid} on:click={(e) => e.stopPropagation()}>{notification.sender_username}</a>
                {#if notification.sender_userareaname}<span class="badge">{notification.sender_userareaname} Official</span>{/if}
                replied to your {notification.type == Common.NOTIFICATION_TYPE_ITEM ? "item" : "comment"}:
            </div>
            <div id="notification-content">
                {#if notification.content.length != 0}
                    {@html Common.shredRichContent(notification.content)}
                    {#if notification.content.length >= 200 }...{/if}
                {:else}
                    <i>Comment Deleted.</i>
                {/if}
            </div>
        </div>
    {:else if notification.type === Common.NOTIFICATION_TYPE_OFFICALSAWITEM}
        <div id="notification" class={unread ? 'unread' : ''} on:click={(e) => goToItem(e)}>
            <div id="username">
                An item you posted was seen by an Area Official:
            </div>
            <div id="notification-content">
                <span style="color:rgb(0,100,200)">{notification.content}</span>
            </div>
        </div>
    {:else if notification.type === Common.NOTIFICATION_TYPE_ITEMLIKE}
        <div id="notification" class={unread ? 'unread' : ''} on:click={(e) => goToItem(e)}>
            <div id="username">
                <a href={"#/user/" + notification.sender_userid} on:click={(e) => e.stopPropagation()}>{notification.sender_username}</a>
                    {#if notification.sender_userareaname}<span class="badge">{notification.sender_userareaname} Official</span>{/if}
                    liked your item:
            </div>
            <div id="notification-content">
                <span style="color:rgb(0,100,200)">{notification.content}</span>
            </div>
        </div>
    {:else if notification.type === Common.NOTIFICATION_TYPE_COMMENTLIKE}
        <div id="notification" class={unread ? 'unread' : ''} on:click={(e) => goToComment(e)}>
            <div id="username">
                <a href={"#/user/" + notification.sender_userid} on:click={(e) => e.stopPropagation()}>{notification.sender_username}</a>
                    {#if notification.sender_userareaname}<span class="badge">{notification.sender_userareaname} Official</span>{/if}
                    liked your comment:
            </div>
            <div id="notification-content">
                {#if notification.content.length != 0}
                    {@html Common.shredRichContent(notification.content)}
                    {#if notification.content.length >= 200 }...{/if}
                {:else}
                    <i>Comment Deleted.</i>
                {/if}
            </div>
        </div>
    {/if}
</div>
{/if}